import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { showMembershipPopup } from './authentication';

export const useShowMembershipPopup = () => {
  const location = useLocation();
  const [showPopup, setShowPopup] = useState(false);
  const [oldPathname, setOldPathname] = useState(location.pathname);
  useEffect(() => {
    if (oldPathname !== location.pathname) {
      setOldPathname(location.pathname);
      setShowPopup(showMembershipPopup());
    }
  }, [location, oldPathname]);
  return showPopup;
};
